import {
  Pane,
  majorScale,
  Button,
  ChevronLeftIcon,
  Heading,
} from 'evergreen-ui'
import React, { FC, useState } from 'react'
import { Helmet } from 'react-helmet-async'
import { useNavigate } from 'react-router-dom'
import CommentsWidget from '../../../components/DashboardWidgets/CommentsWidget/CommentsWidget'
import SearchBox from '../../../components/SearchBox/SearchBox'
import { CONSTANTS } from '../../../constants'
import { useAppSelector } from '../../../hooks'
import { User } from '../../../types'
import {
  generatePageTitle,
  generateSubpageTitle,
} from '../../../utils/generate-page-title'
import styles from './AllComments.module.scss'

interface AllCommentsProps {}

const AllComments: FC<AllCommentsProps> = () => {
  let navigate = useNavigate()

  const [search, setSearch] = useState('')

  const user: User | undefined = useAppSelector((state) => state.auth.user)
  const title = generateSubpageTitle(CONSTANTS.TITLES.DASHBOARD, 'Comments')

  // Navigate back to patient videos page
  const goBack = () => {
    navigate(`${CONSTANTS.ROUTES.DASHBOARD}`)
  }

  return (
    <Pane
      flex={4}
      className={styles.AllComments}
      data-testid="AllComments"
      padding={majorScale(4)}
      background="tint2"
    >
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <Button
        appearance="secondary"
        onClick={() => goBack()}
        marginBottom={majorScale(3)}
        iconBefore={ChevronLeftIcon}
      >
        Back
      </Button>
      <Pane marginY={majorScale(4)}>
        <Heading size={800} marginBottom={majorScale(2)}>
          All comments
        </Heading>
        <Pane
          display="flex"
          flexDirection="column"
          flexWrap="wrap"
          justifyContent="space-between"
          gap={majorScale(3)}
        >
          <Pane display="flex">
            <SearchBox
              doSearch={(term) => setSearch(term)}
              width="100%"
              placeholder="Search"
            ></SearchBox>
          </Pane>
          <Pane flex="1">
            <CommentsWidget user={user} search={search}></CommentsWidget>
          </Pane>
        </Pane>
      </Pane>
    </Pane>
  )
}

export default AllComments
